import React from 'react';
import Collapsible from 'react-collapsible';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

export default class ProductInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            description: props.product.description,
            technicalDescription: props.product.specifications,
            contentType: props.product.contentType,
            mobile: props.mobile,
            productType: props.product.productType,
            product: props.product,
            prodInfo: true,
            prodDetail: this.props.prodDetail,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.prodDetail !== this.state.prodDetail)
            this.setState({ prodDetail: this.props.prodDetail });
    }

    getTechnicalDescription = () => {
        let allLines = [];
        let technicalDescription = this.state.technicalDescription;
        if (
            technicalDescription &&
            (process.env.REACT_APP_STORE !== 'store1' ||
                (this.state.product.productType !== 3 && this.state.product.productType !== 4))
        ) {
            if (
                this.state.product.contentType &&
                (this.state.product.contentType.includes('Icecat') ||
                    this.state.product.contentType.includes('inRiver'))
            ) {
                technicalDescription.forEach(function (item) {
                    allLines.push(
                        <tr colSpan={2} className={'group-heading'}>
                            <td>
                                <h2>{item.name}</h2>
                            </td>
                        </tr>
                    );
                    item.attributes.forEach(function (spec, index) {
                        allLines.push(
                            <tr className={index % 2 === 0 ? 'even' : 'odd'}>
                                <td>{spec.name}</td>
                                <td>{spec.value.join(', ')}</td>
                            </tr>
                        );
                    });
                });
            } else {
                technicalDescription.forEach(function (item) {
                    item.attributes.forEach(function (spec) {
                        let oneLine = (
                            <tr>
                                <td>{spec.value}</td>
                            </tr>
                        );
                        allLines.push(oneLine);
                    });
                });
            }
        }
        return allLines;
    };

    triggerOpen = (name) => {
        return (
            <span>
                <h3 className={'desc-header' + (this.state.mobile ? ' mobile' : '')}>{name}</h3>
                <MinusOutlined className={'desc-header-sign'} />
            </span>
        );
    };

    triggerClosed = (name) => {
        return (
            <span>
                <h3 className={'desc-header' + (this.state.mobile ? ' mobile' : '')}>{name}</h3>
                <PlusOutlined className={'desc-header-sign'} />
            </span>
        );
    };

    closeProdInfo = () => {
        this.setState({ prodInfo: false });
    };

    render() {
        const { description, prodInfo, prodDetail } = this.state;
        const technicalDesc = this.getTechnicalDescription();
        return (
            <div className="prodinfo">
                <div className="collapsible-div">
                    <Collapsible
                        className={'product-description-collapsible'}
                        easing={'ease-in'}
                        trigger={this.triggerClosed('Vörulýsing')}
                        triggerWhenOpen={this.triggerOpen('Vörulýsing')}
                        open={prodInfo}
                    >
                        <div
                            id={'product-description'}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                        {this.state.product.manufacturerURL && (
                            <p id="manufacturer-url">
                                <a target="__blank" href={this.state.product.manufacturerURL}>
                                    Skoða vöru á vef framleiðanda
                                </a>
                            </p>
                        )}
                    </Collapsible>
                    {prodDetail || !this.state.technicalDescription || technicalDesc.length <= 0 ? (
                        ''
                    ) : (
                        <div id="collapsible-fader" />
                    )}
                    {this.state.technicalDescription && technicalDesc.length > 0 ? (
                        <Collapsible
                            className={
                                'technical-description-collapsible' + (!prodDetail ? ' closed' : '')
                            }
                            easing={'ease-in'}
                            trigger={this.triggerClosed('Tækniupplýsingar')}
                            triggerWhenOpen={this.triggerOpen('Tækniupplýsingar')}
                            open={prodDetail}
                            onOpening={this.props.openProdDetail}
                            onClosing={this.props.closeProdDetail}
                        >
                            <div id={'technical-description'}>
                                <table>
                                    <tbody>{this.getTechnicalDescription()}</tbody>
                                </table>
                            </div>
                        </Collapsible>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    }
}
